import React, { Component } from 'react'
import SearchIcon from '../../icons/searchicon'
import service from '../../services';
import moment from 'moment-timezone'
import ReactPaginate from 'react-paginate';
import Loader from '../../component/loader';

let sub;
export default class PartnerUserActivities extends Component {
    constructor(props){
        super(props)
        this.state={
            activities: [],
            offset: 0,
            perPage: 50,
            currentPage: 0,
            pageCount: 0,
            loaderFlag:false,
            totalDocs:0,
            searchText:''
        }
        this.apiserve = new service();
    }
    componentDidMount(){
        this.getActivities()
        var self = this
        sub = this.apiserve.getevent().subscribe(response => {
            switch (response.event) {
                case "privateScreeningPartner|screeningTrack|getList":
                    if (!response.error) {
                        this.setState({
                            activities: response.data.docs || [],
                            pageCount: Math.ceil(response.data.totalDocs / self.state.perPage),
                            loaderFlag:false,
                            totalDocs : response.data.totalDocs || 0
                        })

                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                        this.setState({loaderFlag:false})
                    }
                    break;
            }
        });
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    getActivities(){
        this.setState({loaderFlag: true})
        var data = {
            page: this.state.offset,
            limit: this.state.perPage
        }
        if(this.state.searchText){
            data.filter= this.state.searchText;
        }
        this.apiserve.sendevent("privateScreeningPartner|screeningTrack|getList", data);
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                this.getActivities(offset, this.state.perPage);
            }
        );
    };

    searchData= (e) =>{
        if(e.target.value && e.target.value.length > 0){
            this.setState({searchText : e.target.value},()=>{
                this.getActivities()
            })
        }
        else{
            this.setState({searchText :''},()=>{
                this.getActivities()
            })
        }
       
    }
    render() {
        return (
            <div className="right_side_wrapper adminDashboard_wrapper">
                <div className="dashboard_header with_btn">
                    <div className="searchBlock">
                        <span>All Viewers ({this.state.totalDocs})</span>
                        <form>
                            <input type="text" placeholder="Search" id="searchText" name="searchText" value={this.state.searchText} onChange={(e)=>this.searchData(e)}/>
                            <button type="button"><SearchIcon /></button>
                        </form>
                    </div>

                </div>
                <div className="dashboard_data film_list_table">
                    <table className="tbl_layout_fix">
                        <thead>
                            <tr>
                                <th className="pl_25" style={{width:"220px"}}><span> Email</span></th>
                                <th style={{width:"110px"}}><span> First Name</span></th>
                                <th style={{width:"130px"}}><span> Last Name</span></th>
                                <th style={{width:"120px"}}><span> Film </span></th>
                                <th style={{width:"130px"}}><span>Screening Date Time (MT) </span></th>
                                <th style={{width:"130px"}}><span>First Watch Now Date Time (MT)</span></th>
                                <th style={{width:"110px"}}><span>IP Address</span></th>
                                <th style={{width:"100px"}}><span>20 Min Flag</span></th>
                                <th style={{width:"110px"}}><span> Joined Waiting Room?</span></th>
                                <th style={{width:"100px"}}><span> Joined QA Live?</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.activities.map(item =>{
                                    return(
                                        <tr>
                                        <td className="pl_25" style={{width:"220px"}}>{item?.userId?.email}</td>
                                        <td style={{width:"110px"}}>{item?.userId?.fname}</td>
                                        <td style={{width:"130px"}}>{item?.userId?.lname}</td>
                                        <td style={{width:"120px"}}>{item?.filmId?.title}</td>
                                        <td style={{width:"130px"}}>{item?.screenId?.screeningDate ? moment(item?.screenId?.screeningDate).tz('US/Mountain').format('MM/DD/YYYY hh:mm A'): ''} </td>
                                        <td style={{width:"130px"}}>{item?.FirstWatchDateTime ? moment(item?.FirstWatchDateTime).tz('US/Mountain').format('MM/DD/YYYY hh:mm A'): ''}</td>
                                        <td style={{width:"110px"}}>{item?.ipAddress}</td>
                                        <td style={{width:"100px"}}>{item.TwentyMinFlag ? 'Y' : 'N'}</td>
                                        <td style={{width:"110px"}}>{item.JoinTheWaitingRoom ? 'Y' : 'N'}</td>
                                        <td style={{width:"100px"}}>{item.JoinedQALive ? 'Y' : 'N'}</td>
                                    </tr>
                                    )
                                })
                            }
                           
                        </tbody>
                    </table>
                    {this.state.activities && this.state.activities.length ? (
                                <div className="custom-pagination">
                                    <ReactPaginate
                                        previousLabel={""}
                                        nextLabel={""}
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={this.state.pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        forcePage={this.state.currentPage}
                                    />
                                </div>
                            ) : (
                                    ""
                                )}
                </div>
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}
            </div>
        )
    }
}
